export enum AppRoutes {
  ROOT = "/",
  HOME = "/home",

  STUDY = "/study",
  COMPLIANCE_SETTING = "/study/compliance_setting",
  EDIT_COMPLIANCE_SETTING = "/study/compliance_setting/edit",
  COMPLIANCE_SETTING_CHANGE_LOGS = "/study/compliance_setting/change_logs",
  STUDY_MONITOR_COMPLIANCE = "/study/monitor_compliance",
  STUDY_DETAIL = "/study/detail",
  STUDY_DETAIL_CHANGE_LOGS = "/study/detail/change_logs",
  STUDY_SITES = "/study/sites",
  STUDY_SITE_CHANGE_LOGS = "/study/sites/change_logs",
  STUDY_USERS = "/study/users",
  STUDY_USERS_CHANGE_LOGS = "/study/users/change_logs",
  STUDY_CHANGE_LOGS = "/study/change_logs",
  STUDY_NON_COMPLIANT_DETAIL = "/study/non_compliant_detail",
  STUDY_PARTICIPANT_COMPLIANCE = "/study/participant_compliance",
  STUDY_TEST_TOOL = "/study/test_tool",

  SITE = "/site",
  SITE_MONITOR_COMPLIANCE = "/site/monitor_compliance",
  SITE_PARTICIPANTS = "/site/participants",
  SITE_USERS = "/site/users",
  SITE_USERS_CHANGE_LOGS = "/site/users/change_logs",
  ADD_NEW_PARTICIPANT = "/site/participants/add",
  SITE_PARTICIPANT = "/site/participant",
  EDIT_PARTICIPANT_ID = "/site/participant/edit_participant_id",
  CHANGE_PARTICIPANT_STATUS = "/site/participant/change_status",
  STUDY_PARTICIPANT_CHANGE_LOGS_BY_STUDY = "/site/participants/change_logs",
  ASSIGN_WATCH = "/site/participant/assign_watch",
  MANAGE_WATCH = "/site/participant/manage_watch",
  SWAP_WATCH = "/site/swap_watch",
  SITE_PARTICIPANT_COMPLIANCE = "/site/participant_compliance",
  SITE_NON_COMPLIANT_DETAIL = "/site/non_compliant_detail",
  STUDY_PARTICIPANT_CHANGE_LOGS_BY_STUDY_SITE = "/site/participants/change_logs",
  STUDY_PARTICIPANT_CHANGE_LOGS_BY_STUDY_PARTICIPANT = "/site/participant/change_logs",
  SITE_TEST_TOOL = "/site/test_tool",

  ADMIN = "/admin",
  ADMIN_STUDIES = "/admin/studies",
  ADMIN_TEST_TOOL = "/admin/test_tool",

  ACCESS_DENIED = "/accessdenied",
  LOGOUT = "/logout",
}
